import React from 'react';
import classNames from 'classnames';
import { ITextAreaProps } from './interface';
import { Input } from 'antd';
import BottomHint from './component/BottomHint';
import ABSField from '../ABSField';
import './index.less';

class Textarea extends React.Component<ITextAreaProps> {
  renderBottomHint() {
    const {
      bottomTextClassName,
      areaMaxLen,
      value = ''
    } = this.props;
    if (areaMaxLen) {
      return <BottomHint value={value} areaMaxLen={areaMaxLen} className={bottomTextClassName} />;
    }
    return null;
  }

  render() {
    const {
      value,
      placeholder,
      disabled,
      defaultValue,
      className,
      style,
      autosize,
      height,
      disableResize,
      areaMaxLen,
      onCopy,
      onChange,
      result,
      title,
      required,
      labelWidth,
      removePaddingLeft,
      removeMarginBottom,
      isVertical,
      contentWidth,
      desc
    } = this.props;
    const clazz = classNames(
      'abs-input',
      'abs-textarea-field',
      className
    );

    const textAreaClasses = classNames('abs-native-scrollbar', 'abs-textarea', {
      'textarea-resize-disabled': disableResize,
      'textarea-padding-bottom': areaMaxLen,
    });
    const textAreaStyle = height ? { ...style, height: height } : style;
    return (
      <ABSField
        result={result}
        className={clazz}
        title={title}
        required={required}
        labelWidth={labelWidth}
        removePaddingLeft={removePaddingLeft}
        removeMarginBottom={removeMarginBottom}
        desc={desc}
        isVertical={isVertical}
        contentWidth={contentWidth}
      >
        <div className="abs-textarea-container">
          <Input.TextArea
            placeholder={placeholder}
            disabled={disabled}
            defaultValue={defaultValue}
            onChange={onChange}
            style={textAreaStyle}
            className={textAreaClasses}
            onCopy={onCopy}
            value={value}
            autosize={autosize}
          />
          {this.renderBottomHint()}
        </div>
      </ABSField>
    );
  }
}

export default Textarea;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSInput/TextArea.tsx